import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ScrollService {
  private route = inject(ActivatedRoute);

  public scrollToFragment() {
    const fragment = this.route.snapshot.fragment;
    if (!fragment) {
      return;
    }

    const element = document.getElementById(fragment);
    element?.scrollIntoView();
  }
}
